import React from 'react';
import { Route, IndexRoute } from 'react-router';
import EngajeReading from './engajeReading';
export default (
  <Route path="engaje-reading">
    <IndexRoute component={props => <EngajeReading {...props} />} />
  </Route>
);
